export const sizeClass = (size) => {
  return `size-${size.toLowerCase()}`;
};
